<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="departments"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    :loading="loading"
    clearable
    :hide-details="hideDetails"
  ></v-autocomplete>
</template>

<script>
import { Department } from '@/plugins/api'
import utils from '@/plugins/utils.js'

export default {
  data: () => ({
    departments: [],
    loading: false,
  }),
  props: {
    filter: Object,
    defaultDepartments: Object,
    options: Object,
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.defaultDepartments) {
      this.departments = this.defaultDepartments
    }

    this.fetchAllDepartments()
  },
  methods: {
    async fetchAllDepartments() {
      this.loading = true
      this.departments = await Department.fetch({
        ...this.filter,
        _limit: -1,
      })
      this.departments = this.departments.sort((a, b) => utils.sortAlphabetVietnamese(a.title, b.title))
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter() {
      this.fetchAllDepartments()
    },
  },
}
</script>
